import React, { useEffect, useState } from "react";
import { getMSAuthToken } from "../../utils/MsGraphApiCall";
import { GraphFileBrowser } from "@microsoft/file-browser";
import FolderSharedRoundedIcon from "@mui/icons-material/FolderSharedRounded";
import { PageHeader, PageShell } from "../../components/UI/Page";
import { LoadingState } from "../../components/UI/States";

const SharePoint = () => {
  const [token, setToken] = useState(null);

  const getAuthenticationToken = () => {
    if (token) {
      return new Promise((resolve) => {
        resolve(token);
      });
    }
  };

  useEffect(() => {
    getMSAuthToken(setToken);
  }, []);

  useEffect(() => {
    // Find the element with the data-automationid attribute
    const elementToHide = document.querySelector(
      '[data-automationid="malwareDownloadCommand"]'
    );

    // Check if the element exists before attempting to hide it
    if (elementToHide) {
      elementToHide.style.display = "none";
    }
  }, [token]);

  return (
    <div className="app-canvas min-h-[calc(100vh-140px)] w-full">
      <PageShell size="2xl">
        <PageHeader
          icon={FolderSharedRoundedIcon}
          tone="sky"
          eyebrow="Everyday Tools"
          title="SharePoint"
          description="Browse and open the company's SharePoint files."
        />
        <div className="app-card overflow-hidden rounded-2xl border">
          {token ? (
            // Microsoft's file browser ships its own light (Fabric) styling,
            // so it sits on a deliberately light island in every theme.
            <div className="app-light-surface min-h-[28rem] overflow-x-auto bg-white p-2 text-slate-900 sm:p-3">
              <GraphFileBrowser
                getAuthenticationToken={getAuthenticationToken}
                endpoint="https://graph.microsoft.com/v1.0/sites/bigclumberinc.sharepoint.com,1d5cd21c-1bab-4e4d-91d1-97308132fcb4"
              />
            </div>
          ) : (
            <LoadingState label="Connecting to SharePoint…" />
          )}
        </div>
      </PageShell>
    </div>
  );
};

export default SharePoint;
